<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" >
      <b-col cols="10">
        <b-form inline>
          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="用户名/姓名"
            v-model="queryParam.criteria.keywords"
          ></b-form-input>

          <b-button variant="outline-primary" @click="handleQuery" class="m-1">查询</b-button>
        </b-form>
      </b-col>
      <b-col cols="2">
          <b-button class="m-1 float-right" variant="primary" @click="addUserDialog">增加</b-button>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(actions)="row">
          <b-link @click="deleteUser(row.item.id)" class="mr-3">删除</b-link>
          <b-link v-if="row.item.roles.indexOf('org_fin')!=-1 || row.item.roles.indexOf('tcs_ent')!=-1" @click="openSetUserEntIdsDialog(row.item)">权限</b-link>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>       

    <!-- 添加对话框 -->
    <b-modal
      id="addUserModal"
      title="添加用户"
      incline
      v-model="addUserDialogVisible"
      @ok="handleAdd"
    >
      <template slot="modal-ok">保存</template>
      <template slot="modal-cancel">取消</template>

      <form>
        <validation-observer ref="addUserForm">
          <validation-provider
              :rules="validators.rules.username"
              :customMessages="validators.msgs.username"
              name="手机号"
              v-slot="validationContext"
              >
            <b-form-group label="手机号" label-cols="3" label-align="right" :invalid-feedback="validationContext.errors[0]" label-for="input_username">
              <b-form-input 
                id="input_username"
                v-model="userAddDto.username" 
                :state="validateState(validationContext)"
                placeholder="请输入手机号作为用户名">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="validators.rules.fullName"
              :customMessages="validators.msgs.fullName"
              name="姓名"
              v-slot="validationContext"
            >
            <b-form-group label="姓名" label-cols="3" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="userAddDto.fullName" 
                :state="validateState(validationContext)"
                placeholder="请输入用户的真实姓名">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="validators.rules.password"
              :customMessages="validators.msgs.password"
              name="密码"
              v-slot="validationContext"
            >
            <b-form-group label="密码" label-cols="3" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                type="password"
                v-model="userAddDto.password" 
                :state="validateState(validationContext)"
                placeholder="密码">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="validators.rules.roles"
              :customMessages="validators.msgs.roles"
              name="角色"
              v-slot="validationContext"
            >
            <b-form-group label="角色" label-cols="3" label-align="right" :invalid-feedback="validationContext.errors[0]">
              <b-form-select
                style="min-width:100px;"
                class="m-1"
                :options="roleList"
                v-model="userAddDto.roles"
              ></b-form-select>
            </b-form-group>
          </validation-provider>


        </validation-observer>
      </form>
    </b-modal>     


    <!-- 设置企业对话框 -->
    <b-modal
      id="setUserEntIdsModal"
      title="设置用户所辖的企业"
      incline
      v-model="setUserEntIdsVisible"
      @ok="handleSetUserEntIds"
    >
      <template slot="modal-ok">保存</template>
      <template slot="modal-cancel">取消</template>

      <form>
        <b-form-group label="如果不选择，表示可以管理所有公司" label-for="tags-component-select">
          <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
          <b-form-tags
            id="tags-component-select"
            v-model="entIds"
            size="lg"
            class="mb-2"
            add-on-change
            no-outer-focus
          >
            <template v-slot="{ tags, entCode, inputHandlers, disabled, removeTag }">
              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                <li v-for="tag in tags" :key="tag" class="list-inline-item">
                  <b-form-tag
                    @remove="removeTag(tag)"
                    :title="tag"
                    :disabled="disabled"
                    variant="info"
                  >{{ tag }}</b-form-tag>
                </li>
              </ul>
              <b-form-select
                v-bind="entCode"
                v-on="inputHandlers"
                :disabled="disabled || availableOptions.length === 0"
                :options="availableOptions"
              >
                <template #first>
                  <!-- This is required to prevent bugs with Safari -->
                  <option disabled value="">选择公司...</option>
                </template>
              </b-form-select>
            </template>
          </b-form-tags>
        </b-form-group>

      </form>
    </b-modal>     

  </div>
</template>

<script>
import * as userFacade from "../../../api/user-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import dayjs from "dayjs";

export default {
  props:{
    orgId: String,
  },
  // validations:
  data() {
    return {
      roleList: [
        { text: "管理员", value: "org_admin" },
        { text: "财务经理", value: "org_fin" },
        { text: "监管单位", value: "tcs_jgdw" },
        { text: "企业", value: "tcs_ent" },
      ],

      fields: [
        {
          key: "username",
          label: "用户名"
        },
        {
          key: "fullName",
          label: "姓名"
        },
        {
          key: "friendlyRoles",
          label: "角色"
        },
        {
          key: "timeCreated",
          label: "创建时间",
          formatter: value => {
            return value != null
              ? dayjs(new Date(value)).format("YYYY-MM-DD HH:mm:ss")
              : "";
          }
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],
      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: this.orgId,
          keywords: "",
        },
        sortOrder: { username: "descending" }
      },
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      userAddDto: {
        orgId: this.orgId,
        username: "",
        fullName: "",
        roles:"org_fin"
      },
      addUserDialogVisible: false,
      setUserEntIdsVisible: false,
      userDto:{},
      entList:[],
      entIds:[],

      // 错误提示
      validators: {
        rules: {
          username: {
            required: true,
            regex: /1[3|4|5|7|8][0-9]\d{8}/
          },
          fullName: {
            required: true,
            max: 10
          },
          password: {
            required: true,
            regex: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
          },
          roles: {
            required: true,
          }
        },
        msgs: {
          username: {
            required: "手机号不能为空",
            regx: "请输入合法的手机号"
          },
          fullname: {
            required: "姓名不能为空",
            max: "长度不能超过10个字符"
          },
          password: {
            required: "密码不能为空",
            regex: "密码要求字母数字组合,6到20个字符"
          },
          roles: {
            required: "企业名称不能为空",
          }
        }
      },
    };
  },

  created() {
    this.init()
  },
  mounted() {
    // 异步加载列表数据
    this.handleQuery();
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    init(){
        entFacade
          .findByOrgId(this.orgId)
          .then(res => {
            this.parseEntInfo(res)
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });

    },
    //解析企业信息
    parseEntInfo(res) {
      if (res) {
        res.map(item => {
          let ent = {};
          ent.text = item.entName;
          ent.value = item.entCode;
          this.entList.push(ent);
        });
      }
    },
    // 异步加载列表数据
    list(page) {
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      userFacade
        .list(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    handleQuery(){
      this.list()
    }, 
    
    deleteUser(id){
      this.$bvModal
        .msgBoxConfirm("确认要删除该用户吗？", {
          title: "确认",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "删除",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if(value){
            this.handleDelete(id)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    handleDelete(id){
      console.log(id)
      userFacade
        .deleteUser(id) // 异步调用后台接口
        .then(() => {
          this.$message({
            message: "删除用户成功",
            type: "success"
          });
          this.list()
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    addUserDialog(){
      this.addUserDialogVisible=true;
    },

    handleAdd(e){
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      this.$refs.addUserForm.validate().then(success => {
        if (!success) {
          return;
        }
        userFacade
          .add(this.userAddDto)
          .then(() => {
            this.$message({
              message: "添加用户成功",
              type: "success"
            });
            this.list();
          })
          .catch(err => {
            console.log("err", err);
          });
          this.addUserDialogVisible = false
          this.userAddDto={orgId: this.orgId, username:"", fullName:"", password:"", roles:"org_fin"}; 

     })
    },

    // 打开设置用户企业的对话框
    openSetUserEntIdsDialog(val){
      this.userDto = val;
      if(val.entIds != null){
        this.entIds = val.entIds;
      }else{
        this.entIds = [];
      }
      this.setUserEntIdsVisible = true;
    },

    // 保存用户的企业权限
    handleSetUserEntIds(){
        // 执行人工审核操作
        this.pageLoading = true;
        this.userDto.entIds = this.entIds;
        userFacade
          .setEntIds(this.userDto)
          .then(() => {
            this.pageLoading = false;
            // this.invoiceCheckDto = res;
            this.$message({
              message: "用户企业权限设置成功",
              type: "success"
            });
            // this.list();
          })
          .catch(err => {
            this.pageLoading = false;
            console.log("err", err);
          });
          this.setUserEntIdsVisible = false
          this.entIds=[]
    }
  },
  computed: {
    availableOptions() {
      return this.entList.filter(opt => this.entIds.indexOf(opt.value) === -1)
    }
  }

};
</script>

<style >
</style>
